import React from 'react';
import { EntityUIState, EntityUIStateWrapper } from '../../../core/interfaces/entitiy-ui-state';
import { getArrayFromSize } from '../../../core/utils/array';
import { RecoveryCode } from '../../interfaces/recoveryCode';
import styles from './TfaCodeList.module.scss';

interface TFACodeListProps {
  uiState?: EntityUIStateWrapper;
  codes: RecoveryCode[];
}

function TFACodeList({ uiState, codes }: TFACodeListProps) {
  const shimmerCodes = getArrayFromSize(5);
  const loaded = uiState.state === EntityUIState.IDLE;
  const loading = uiState.state === EntityUIState.LOADING;

  return (
    <div className={styles.wrapper} data-id='recovery-codes-dialog-code-list'>
      {loaded ? (
        <div className={styles.recoveryCodes}>
          {codes.map(code => (
            <div className={styles.recoveryCodeWrapper} key={code.value}>
              <div className={`${styles.recoveryCode} ${!code.active ? styles.disabled : ''}`}>
                {code.active ? code.value : 'Used'}
              </div>
            </div>
          ))}
        </div>
      ) : null}

      {loading ? (
        <div className={styles.recoveryCodes}>
          {shimmerCodes.map(index => (
            <div className={styles.recoveryCodeWrapper} key={index}>
              <div className={styles.recoveryCode}>
                <div className='shimmer shimmer-line' />
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default TFACodeList;
